/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import React, {useContext} from 'react';
import {Dialog, Snackbar} from '@dvrd/dvr-controls';

import {AppContext} from "../context/appContext";

export default function PopupController() {
    const context = useContext(AppContext);

    function renderUnauthenticated() {
        return (
            <>
                <Dialog/>
                <Snackbar/>
            </>
        )
    }

    function renderAuthenticated() {
        const {user} = context.userContext;
        if (!user) return null;
        return (
            <></>
        );
    }

    return (
        <>
            {renderUnauthenticated()}
            {renderAuthenticated()}
        </>
    )
}